<div class="mb-3 d-none" id="divPrivacyQuestionOptions">
  <label for="privacyQuestionsOptionsSet" class="form-label">What would you like to know about privacy on MealPlanner?</label>
  <select id="privacyQuestionsOptionsSet" name="privacyQuestionsOptionsSet" class="form-select" aria-label="Default select example"
    [formControl]="this.contactForm.controls.privacyQuestionsOptionsSet" (change)="handlePrivacyQuestionOptionsSetChange()" value="0">
    <option selected value="">Select one</option>
    <option value="1">MealPlanner Privacy Policy</option>
    <option value="2">MealPlanner feature privacy choices</option>
    <option value="3">EU-US Privacy Sheild program</option>
    <option value="4">Cancellation of data</option>
    <option value="5">Modifying the information MealPlanner has about me</option>
    <option value="6">How MealPlanner processes my data</option>
    <option value="7">Other questions about privacy or data protection</option>
  </select>
  <div
    *ngIf="this.contactForm.controls.privacyQuestionsOptionsSet.invalid && (this.contactForm.controls.privacyQuestionsOptionsSet.dirty || this.contactForm.controls.privacyQuestionsOptionsSet.touched)"
    class="alert alert-danger">
    <div *ngIf="this.contactForm.controls.privacyQuestionsOptionsSet.hasError('required')">
      Please make a selection from the list of options.
    </div>
    <div *ngIf="this.contactForm.controls.privacyQuestionsOptionsSet.hasError('min') || this.contactForm.controls.privacyQuestionsOptionsSet.hasError('max')">
      Please select a valid option from the list of options.
    </div>
  </div>
</div>

<form>
  <div class="mb-3  d-none" id="privacyQuestionOptionOneResponse">
    <div class="card card-privacy-policy mb-3">
      <h5 class="card-header">MealPlanner privacy policy questions</h5>
      <div class="card-body">
        <p class="card-text">Got questions about <a href="/privacy_policy">MealPlanner’s Privacy Policy</a>? You’re in the right place!</p>
        <p>For anything else, our other support options are here to help. Reach out and we’ll get you sorted!</p>
      </div>
    </div>

    <div class="card">
      <div class="input-group mb-3">
        <span class="input-group-text">Please ask your question here</span>
        <textarea class="form-control" aria-label="With textarea"></textarea>
      </div>

      <div class="input-group mb-3">
        <label for="userNamePrivacyQuestion" class="form-label">Enter your username</label>
        <input id="userNamePrivacyQuestion" name="userNamePrivacyQuestion" type="text" class="form-control" placeholder="Username" aria-label="Username"
          aria-describedby="basic-addon2">
      </div>

      <div class="input-group mb-3">
        <label for="emailPrivacyQuestion" class="form-label">Enter your email address</label>
        <input id="emailPrivacyQuestion" name="emailPrivacyQuestion" type="text" class="form-control" placeholder="example@mail.com" aria-label="Email Address">
      </div>
    </div>
  </div>
</form>
